// @ts-nocheck

/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { GetSubscriptionSubscriptionsGetQueryResponse } from "../models/subscriptionsController/GetSubscriptionSubscriptionsGet.ts";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@kubb/plugin-client/clients/axios";
import type {
  QueryKey,
  QueryClient,
  UseQueryOptions,
  UseQueryReturnType,
} from "@tanstack/vue-query";
import { getSubscriptionSubscriptionsGet } from "../client/getSubscriptionSubscriptionsGet.ts";
import { queryOptions, useQuery } from "@tanstack/vue-query";
import { toValue } from "vue";

export const getSubscriptionSubscriptionsGetQueryKey = () =>
  [{ url: "/subscriptions/" }] as const;

export type GetSubscriptionSubscriptionsGetQueryKey = ReturnType<
  typeof getSubscriptionSubscriptionsGetQueryKey
>;

export function getSubscriptionSubscriptionsGetQueryOptions(
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getSubscriptionSubscriptionsGetQueryKey();
  return queryOptions<
    GetSubscriptionSubscriptionsGetQueryResponse,
    ResponseErrorConfig<Error>,
    GetSubscriptionSubscriptionsGetQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getSubscriptionSubscriptionsGet({
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Get current subscription with details for authenticated user.
 * @summary Get Subscription
 * {@link /subscriptions/}
 */
export function useGetSubscriptionSubscriptionsGet<
  TData = GetSubscriptionSubscriptionsGetQueryResponse,
  TQueryData = GetSubscriptionSubscriptionsGetQueryResponse,
  TQueryKey extends QueryKey = GetSubscriptionSubscriptionsGetQueryKey,
>(
  options: {
    query?: Partial<
      UseQueryOptions<
        GetSubscriptionSubscriptionsGetQueryResponse,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    (resolvedOptions && "queryKey" in resolvedOptions
      ? toValue(resolvedOptions.queryKey)
      : undefined) ?? getSubscriptionSubscriptionsGetQueryKey();

  const query = useQuery(
    {
      ...getSubscriptionSubscriptionsGetQueryOptions(config),
      ...resolvedOptions,
      queryKey,
    } as unknown as UseQueryOptions<
      GetSubscriptionSubscriptionsGetQueryResponse,
      ResponseErrorConfig<Error>,
      TData,
      GetSubscriptionSubscriptionsGetQueryResponse,
      TQueryKey
    >,
    toValue(queryClient),
  ) as UseQueryReturnType<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey;
  };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
